export function cleanPayload<T>(value: T): T | undefined {
  if (value === undefined) return undefined;

  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed === "" ? undefined : (trimmed as T);
  }

  if (Array.isArray(value)) {
    const cleanedArray = value.map(cleanPayload).filter((v) => v !== undefined);

    return cleanedArray.length > 0 ? (cleanedArray as T) : undefined;
  }

  if (typeof value === "object" && value !== null) {
    const cleanedObject = Object.fromEntries(
      Object.entries(value)
        .map(([key, val]) => [key, cleanPayload(val)])
        .filter(([, val]) => val !== undefined),
    );

    return Object.keys(cleanedObject).length > 0
      ? (cleanedObject as T)
      : undefined;
  }

  return value;
}
